module.exports = __webpack_public_path__ + "static/img/nav4.bac2809.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/nav4.png
// module id = 935W
// module chunks = 1